export default {
  title: "Seleccionar color de fondo",
  labels: {
    r: "R:",
    g: "G:",
    b: "B:",
    hex: "HEX:"
  },
  buttons: {
    cancel: "Cancelar",
    apply: "Aplicar"
  }
}
